import { useCallback, useState } from "react";
import { SendChannel, SEND_CHANNELS } from "@/entities/dreamerEmail/types";

const STORAGE_KEY = "dreamer-draft-email-default-channel";

// Sticky "default send method", persisted on the device (the app's local-
// preference pattern, see useKanbanCollapsedColumns). Null until the user picks
// one, which flips the Send button from the single-button to the split layout.
export const useDefaultEmailProvider = () => {
  const getInitial = (): SendChannel | null => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved && SEND_CHANNELS.includes(saved as SendChannel)
        ? (saved as SendChannel)
        : null;
    } catch {
      // localStorage can throw (private mode / quota); fall back to no default.
      return null;
    }
  };

  const [defaultChannel, setDefaultChannelState] = useState<SendChannel | null>(
    getInitial
  );

  const setDefaultChannel = useCallback((channel: SendChannel) => {
    setDefaultChannelState(channel);
    try {
      localStorage.setItem(STORAGE_KEY, channel);
    } catch {
      // localStorage can throw (private mode / quota); the in-memory state still
      // updated, so the default works for this session even if it didn't persist.
    }
  }, []);

  return { defaultChannel, setDefaultChannel };
};
